import { Avatar, Badge, Tooltip } from "antd";
import type { components } from "../helper";
import { formatDate } from "../helper/method";

export default function TicketUserItem({
  data,
  ticketId,
}: {
  data: components["schemas"]["SiteTicketItem"];
  ticketId: string;
}) {
  const avatarColors = [
    "bg-info-500!",
    "bg-success-500!",
    "bg-warning-500!",
    "bg-error-500!",
  ];
  const colorClass =
    avatarColors[data.u_id.charCodeAt(0) % avatarColors.length];
  return (
    <div
      className={`flex gap-4 py-4 px-6 ${ticketId === data.u_id ? "bg-grayscale-100" : "hover:bg-grayscale-100"}`}
    >
      <div>
        <Tooltip title={data.user_name}>
          <Badge
            color={data.status !== 3 ? "green" : "red"}
            count={data.status !== 3 ? "باز" : "بسته"}
          >
            <Avatar size="large" className={`w-12! h-12! ${colorClass}`}>
              {data.user_name?.at(0)}
            </Avatar>
          </Badge>
        </Tooltip>
      </div>
      <div className="flex flex-col h-full justify-center gap-1 flex-1">
        <div className="w-full! flex justify-between">
          <span
            className={`${data.unread_message ? "text-16-semi-bold" : "text-16-regular"} text-right text-wrap line-clamp-1 break-all!`}
          >
            {data.title}
          </span>
          <span className="text-16-regular"> {formatDate(data.created)}</span>
        </div>
        <div className="w-full! flex justify-between items-center">
          <span className={`text-14-regular text-grayscale-500`}>
            {data.category}
          </span>
          {data.unread_message ? (
            <span className="relative flex-center size-2">
              <span className="absolute top-0 size-2 animate-ping rounded-full bg-info-500 opacity-75"></span>{" "}
              <span className="size-2 rounded-full bg-info-500"></span>
            </span>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
